import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.12.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema)
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep,
    ignoreRichText = false
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {
    strictMode, ignoreManifest, isValidTime, getMinTimeStep, ignoreRichText
  })

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  // update powtoon content designed in a way to be executed only 1 or 0 time in every powtoon lifecycle
  // it powtoon content version is >= specific function version - this function will never run
  // here we should add missing fields to the powtoon document
  // later steps :
  // validate : we detect the missing asset in manifest , find wrong data and types
  // recovery : will try to fix all that is broken or missing including the manifest
  // part of the recovery will replace and update manifest using api call with all  manifest ids form server
  // this time we will :
  // * add empty captions object to each slide, and add empty styleDefs object to powtoon root
  content.powtoon.styleDefs = {}
  content.powtoon.slides.forEach(slide => {
    slide.captions = {}
  })
}
  
